import moment from 'moment';
import { IRootDispatch } from '../../../store/models';

export const ELITE_ONBOARDING_SCHEDULE_FLAG_NAME = 'pro_elite_onboarding_schedule_atl4332_20220602';

export function openSchedulingWebsite() {
  const yearAndMonth = moment().add(1, 'day').format('YYYY-MM');
  const calendlyUrl = `https://calendly.com/d/x8cq-64g7/onboarding-consultation-30-min?month=${yearAndMonth}`;
  window.open(calendlyUrl, '_system');
}

export type EliteOnboardingCompleteReason = 'scheduled' | 'dismissed' | 'expired';

export const ELITE_ONBOARDING_STATE_KEY = 'pro_elite_onboarding_atl4332';

export type EliteOnboardingState = {
  completedReason?: EliteOnboardingCompleteReason;
};

export function markEliteOnboardingComplete(
  dispatch: IRootDispatch,
  reason: EliteOnboardingCompleteReason,
) {
  dispatch.userState.addValues({
    values: {
      [ELITE_ONBOARDING_STATE_KEY]: {
        completedReason: reason,
      } as EliteOnboardingState,
    },
    preferLocalKeys: [ELITE_ONBOARDING_STATE_KEY],
  });
}
